import React, { useRef, useState } from 'react'
import { motion } from 'framer-motion';
import { ERRORMESSAGE } from '@/utils/constant';
import { validateAboutYou, validateEmail, validateMobile, validateName } from '@/utils/validation';
import { contactUsApi } from '@/components/action/easycampus';
import Popup from '../contactus/popup';

const FaqsForm = ({ isOpen, onClose }) => {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [aboutYou, setAboutYou] = useState("");
  const [addForm, setAddForm] = useState("");
  const [demoForm, setDemoForm] = useState(false);
  const [formMessage, setFormMessage] = useState("");

  // Error Messages
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [lastNameErrorMessage, setLastNameErrorMessage] = useState("");
  const [mobileErrorMessage, setMobileErrorMessage] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [aboutYouErrorMessage, setAboutYouErrorMessage] = useState("");

  // Ref focus for input field
  const nameInputRef = useRef(null);
  const lastNameInputRef = useRef(null);
  const mobileInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const aboutYouInputRef = useRef(null);

  // HANDLE methods
  const handleName = (e) => {
    if (e.target.value.trim() === "") {
      setNameErrorMessage(ERRORMESSAGE.NAME_IS_REQUIRED);
      nameInputRef.current.focus();
    } else {
      setNameErrorMessage(validateName(e.target.value.trim()));
      nameInputRef.current.focus();
    }
    setName(e.target.value);
  };

  const handleLastName = (e) => {
    if (e.target.value.trim() === "") {
    }
    else {
      setLastNameErrorMessage(validateName(e.target.value.trim()));
      lastNameInputRef.current.focus();
    }
    setLastName(e.target.value);
  };

  const handleMobile = (e) => {
    if (e.target.value.trim() === "") {
      setMobileErrorMessage(ERRORMESSAGE.MOBILE_NUMBER_IS_REQURED);
      mobileInputRef.current.focus();
    } else {
      setMobileErrorMessage(validateMobile(e.target.value.trim()));
      mobileInputRef.current.focus();
    }
    setMobile(e.target.value);
  };

  const handleEmail = (e) => {
    if (e.target.value.trim() === "") {
      setEmailErrorMessage(ERRORMESSAGE.EMAIL_IS_REQURED);
      emailInputRef.current.focus();
    } else {
      setEmailErrorMessage(validateEmail(e.target.value.trim()));
      emailInputRef.current.focus();
    }
    setEmail(e.target.value);
  };

  const handleaboutYou = (e) => {
    if (e.target.value.trim() === "") {
      setAboutYouErrorMessage(ERRORMESSAGE.MESSAGE_IS_REQUIRED);
      aboutYouInputRef.current.focus();
    } else {
      setAboutYouErrorMessage(validateAboutYou(e.target.value.trim()));
      aboutYouInputRef.current.focus();
    }
    setAboutYou(e.target.value);
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setNameErrorMessage("");
    setLastNameErrorMessage("");
    setMobileErrorMessage("");
    setEmailErrorMessage("");
    setAboutYouErrorMessage("");

    if (!name) {
      setNameErrorMessage(ERRORMESSAGE.NAME_IS_REQUIRED);
    } else if (name) {
      setNameErrorMessage(validateName(name.trim()));
    }

    if (lastName) {
      setLastNameErrorMessage(validateName(lastName.trim()));
    }

    if (!mobile) {
      setMobileErrorMessage(ERRORMESSAGE.MOBILE_NUMBER_IS_REQURED);
    } else if (mobile) {
      setMobileErrorMessage(validateMobile(mobile.trim()));
    }

    if (!email) {
      setEmailErrorMessage(ERRORMESSAGE.EMAIL_IS_REQURED);
    } else if (email) {
      setEmailErrorMessage(validateEmail(email.trim()));
    }

    if (!aboutYou) {
      setAboutYouErrorMessage(ERRORMESSAGE.MESSAGE_IS_REQUIRED);
    } else if (aboutYou) {
      setAboutYouErrorMessage(validateAboutYou(aboutYou.trim()));
    }

    // For Focus

    if (!name) {
      nameInputRef.current.focus();
      return;
    } else if (name) {
      if (validateName(name.trim())) {
        nameInputRef.current.focus();
        return;
      }
    }

    if (lastName) {
      if (validateName(lastName.trim())) {
        lastNameInputRef.current.focus();
        return;
      }
    }

    if (!mobile) {
      mobileInputRef.current.focus();
      return;
    } else if (mobile) {
      if (validateMobile(mobile.trim())) {
        mobileInputRef.current.focus();
        return;
      }
    }

    if (!email) {
      emailInputRef.current.focus();
      return;
    } else if (email) {
      if (validateEmail(email.trim())) {
        emailInputRef.current.focus();
        return;
      }
    }

    if (!aboutYou) {
      aboutYouInputRef.current.focus();
      return;
    } else if (aboutYou) {
      if (validateAboutYou(aboutYou.trim())) {
        aboutYouInputRef.current.focus();
        return;
      }
    }

    let formData = {
      firstName: name,
      lastName: lastName,
      email: email,
      mobile: mobile,
      message: aboutYou,
    }

    contactUsDataSubmit(formData);
    console.log("formData", formData);

  };

  const contactUsDataSubmit = async (formData) => {
    console.log("lets talk", formData);
    try {

      const response = await contactUsApi(formData);
      if (response.data.hasError == false) {
        setFormMessage(response.data);
        console.log("lets talk formsumbit", response.data.data);
        setDemoForm(true)
        setName("");
        setLastName("");
        setMobile("");
        setEmail("");
        setAboutYou("");
      }

      if (response.data.hasError === true) {
        setFormMessage(response.data);
        setDemoForm(true)
      }

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {demoForm && (
        <Popup
          isOpen={demoForm}
          onClose={() => setDemoForm(false)}
          message={formMessage}
        />
      )}
      <section>
        {isOpen && (
          <div className='model_wrapper'>
            <div className="model_container">
              <button
                onClick={onClose}
                type="button"
                className="crossicon z-10"
                data-modal-hide="default-modal"
              >
                <svg
                  className="crossiconSvg"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
              </button>
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className='col-span-1 lg:col-span-6'>
                <div>
                  <h3 className='text-center pb-5'>
                    Do You Have Questions?
                  </h3>
                </div>
                <div className="max-w-2xl mx-auto bg-white rounded-[15px]" style={{ boxShadow: '0px 0px 10px #51a9ff' }}>
                  <div className="py-4 px-6">
                    <form action="#" method="POST"
                      onSubmit={handleFormSubmit}
                      className="mt-6">
                      <div className="flex flex-wrap -mx-3 mb-4">
                        <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                          <input
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            value={name}
                            ref={nameInputRef}
                            onChange={handleName}
                            className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150" />
                          <div
                            id="nameErrorMessage"
                            className="text-red-500 text-sm">
                            {nameErrorMessage}
                          </div>
                        </div>
                        <div className="w-full md:w-1/2 px-3">
                          <input type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={lastName}
                            onChange={handleLastName}
                            ref={lastNameInputRef}
                            className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150" />
                          <div
                            id="lastNameErrorMessage"
                            className="text-red-500 text-sm">
                            {lastNameErrorMessage}
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={email}
                          ref={emailInputRef}
                          onChange={handleEmail}
                          className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150" />
                        <div
                          id="EmailErrorMessage"
                          className="text-red-500 text-sm">
                          {emailErrorMessage}
                        </div>
                      </div>
                      <div className="mb-4">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Phone Number"
                          ref={mobileInputRef}
                          value={mobile}
                          onChange={handleMobile}
                          pattern="[6789][0-9]{9}"
                          minLength={10}
                          maxLength={10}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150"
                        />
                        <div id="mobileErrorMessage" className="text-red-500 text-sm">
                          {mobileErrorMessage}
                        </div>
                      </div>
                      <div className="mb-4">
                        <textarea name="message"
                          placeholder="Message" rows="5"
                          onChange={handleaboutYou}
                          ref={aboutYouInputRef}
                          value={aboutYou}
                          minLength={20}
                          className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150"></textarea>
                        <div
                          id="aboutYouErrorMessage"
                          className="text-red-500 text-sm">
                          {aboutYouErrorMessage}
                        </div>
                      </div>
                      <div className="mt-6">
                        <button type="submit"
                          className="w-full px-4 py-2 text-white bg-[#1e336a] rounded-md hover:bg-[#51A9FF] focus:outline-none focus:bg-indigo-600 transition duration-150 ease-in-out">Send
                          Message</button>
                      </div>
                    </form>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        )}
      </section>
    </>
  )
}

export default FaqsForm